import { StatisticsConst } from '@/store/constant/statistics.constant'
import type { IGetStaticsAction, IStatistics } from '@/store/models/statistics.model'

export const getStatistics = (data: IStatistics): IGetStaticsAction => ({
    type: StatisticsConst.SET_STATISTICS,
    payload: {
        data
    }
})

export type StatisticsUnionType = IGetStaticsAction